import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaLocationDot, FaTag } from "react-icons/fa6";
import { MdWork } from "react-icons/md";
import ApplyFormModal from '../ApplyFormModal/ApplyFormModal';
import '../Card/Card.css';

export default function HRMSCard({ id, heading, category, type, location, experience, description }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleToggle = () => {
    setIsModalOpen(true);
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100vh';
  };

  const handleClose = () => {
    setIsModalOpen(false);
    document.body.style.overflow = 'visible';
    document.body.style.height = 'auto';
  };

  const getSnippet = (html) => {
    if (!html) return "";
    const cleanText = html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    if (cleanText.length > 100) {
      return cleanText.substring(0, 100) + "...";
    }
    return cleanText;
  };

  return (
    <>
      <div className='card__container'>
        <div style={{ flex: '1', display: 'flex', flexDirection: 'column', gap: '6px' }}>
          <h3 className='card__heading heading1' style={{ fontSize: '18px', color: 'var(--themeDarkBlue)', margin: 0 }}>{heading}</h3>
          <div className='card__details' style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '15px', marginTop: '4px' }}>
            <span className='card__deatils_innerBox'>
              <FaTag size={12} style={{ color: 'var(--themeOrange)' }} />
              <p className='card__Subtitle' style={{ margin: 0 }}>Category: {category}</p>
            </span>
            <span className='card__deatils_innerBox'>
              <FaLocationDot size={12} style={{ color: 'var(--themeOrange)' }} />
              <p className='card__Subtitle' style={{ margin: 0 }}>{location}</p>
            </span>
            <span className='card__deatils_innerBox'>
              <MdWork size={12} style={{ color: 'var(--themeOrange)' }} />
              <p className='card__Subtitle' style={{ margin: 0 }}>{type}</p>
            </span>
            {experience && (
              <span className='card__deatils_innerBox'>
                <p className='card__Subtitle' style={{ margin: 0, fontSize: '12px', color: '#777' }}>Experience: {experience}</p>
              </span>
            )}
          </div>
          {description && (
            <p className='card__description' style={{ margin: '8px 0 0 0', fontSize: '13px', color: '#555', lineHeight: '1.6', fontWeight: '400', fontFamily: 'var(--fontprimary)' }}>
              {getSnippet(description)}
            </p>
          )}
        </div>

        <div className='card__button__container'>
          <Link 
            to={`/job/${id}`} 
            className='card__button card__button--secondary' 
            onClick={() => window.scrollTo(0, 0)}
          >
            View Details
          </Link>
          <button 
            onClick={handleToggle} 
            className='card__button' 
          >
            Apply Now
          </button>
        </div>
      </div>

      <ApplyFormModal 
        jobId={id} 
        jobTitle={heading} 
        isOpen={isModalOpen} 
        onClose={handleClose} 
      />
    </>
  );
}
